import request from "./request";

// 获取字典
export function getDictData(dict) {
  return request.get(`/largescreen/job/type/${dict}`).then((res) => res);
}

// 获取地图配置项
export function getMapSeting(params) {
  return request
    .post("../system/sysLargeScreenConfig/select/list/by-model", params)
    .then((res) => {
      let result = res || [];
      if (result.length > 0) {
        return result[0];
      } else {
        return {};
      }
    });
}

//  AI调度大屏-查询气象预警列表
export function getWeatherWarnList(params) {
  return request
    .get("/largeScreen/aidispatch/getWeatherWarnList", params)
    .then((res) => res);
}

// 通过id查询气象预警详情
export function getWeatherDetail(id) {
  return request
    .get("/largeScreen/aidispatch/weatherWarnRecord/" + id)
    .then((res) => res);
}

//  查询热力、进度预警列表
export function getHeatAndProcessWarnList(params) {
  return request
    .get("/largeScreen/aidispatch/getHeatAndProcessWarnList", params)
    .then((res) => res);
}

// 通过id查询热力、进度预警详情
export function getHarvesterDetail(id) {
  return request
    .get("/largeScreen/aidispatch/warnRecord/" + id)
    .then((res) => res);
}

// AI调度大屏-AI智能机手调度列表
export function getFarmInfoList(params) {
  return request
    .get("/largeScreen/aidispatch/getFarmInfoList", params)
    .then((res) => res);
}

// AI调度大屏-查询各区域机收完成进度
export function getProgressList(params) {
  return request
    .get("/largeScreen/aidispatch/getProgressList", params)
    .then((res) => res);
}

// 查询监控总量(农机总数)、在线数量、总体作业进度
export function getVehicleCount(params) {
  return request
    .get("/largeScreen/aidispatch/getVehicleCount", params)
    .then((res) => res);
}

// 根据农机类型类型查询预警项列表
export function getWarnTypeList(params) {
  return request
    .get("/largeScreen/aidispatch/getWarnTypeList", params)
    .then((res) => res);
}

// 查询收割热力缺口情况
export function getHearGapCountList(params) {
  return request
    .get("/largeScreen/aidispatch/getHearGapCountList", params)
    .then((res) => res);
}

// 获取所有预警列表（大屏地图展示）
export function getAllWarnList(params) {
  return request
    .get("/largeScreen/aidispatch/getAllWarnList", params)
    .then((res) => res);
}

// 获取季度类型（返回SX三夏 SQ三秋）
export function getQuarterType() {
  return request
    .get("/largeScreen/aidispatch/getQuarterType")
    .then((res) => res);
}

// 区域点位维护-根据父级ID查询下级区域列表
export function getAreaLonAndLat(parentId) {
  return request
    .get("../system/area/maintain/getAreaListByParentId/" + parentId)
    .then((res) => {
      let points = res;
      for (let i = 0; i < points.length; i++) {
        // 把经纬度不存在、不符合标准的去掉
        if (
          !points[i] ||
          !points[i].latitude ||
          !points[i].longitude ||
          !points[i].lat ||
          !points[i].lon ||
          (points[i].longitude <= -180 && points[i].longitude >= 180) ||
          (points[i].latitude <= -90 && points[i].latitude >= 90) ||
          (points[i].lon <= -180 && points[i].lon >= 180) ||
          (points[i].lat <= -90 && points[i].lat >= 90)
        ) {
          points.splice(i, 1);
          if (i > 0) {
            i--;
          } else {
            i = 0;
          }
        }
      }
      return points;
    });
}
